<template>
<div >
    <div >
        <h2 class="text-center">Welcome to Users Dashboard</h2>
    </div>
          <div class="col-sm-12">
                <div class="input-group col-md-offset-3 col-md-6">
                    <input type="text"  class="form-control input-lg" v-model="searchData.SearchText" @keyup.enter="getSearchText()" placeholder="Search Users, by ID, Name or Email "/>
                    <span class="input-group-addon">
                       <span class="fa fa-search"></span>
                    </span>
                    
                </div>
                <br>
            </div>
               <div v-if="!loading">
            <div class=" col-md-offset-2 col-md-8"  v-if="usersList.length>0" v-for="(user, index) in usersList">
                <div class="sitterListbox card">
                 
                    <div class="profile-body ">
                       
                    
                                
                        <h2 style="margin-left:13px;" class="small" v-bind:class="{'confirmed': user.IsConfirmedEmail}"> {{user.Email}}</h2>
                            
                        <br>
                            <div class="content col-sm-12">
                                <h4 v-if="!user.IsEnabled" style="margin-top:0px;color:red">User Disabled by admin</h4>
                                <p class="small"> Name: {{user.FirstName}} {{user.LastName}}</p> 
                                
                                <p v-if="user.SitterId!=0" class="small"> SitterId: <strong>{{user.SitterId}}</strong></p> 
                                
                                <div class="confirmed" v-if="user.IsSitterSubscription">
                                            <p class="small text-success">Sitter Subscription StartDate: {{dateFormatter(user.SitterSubscriptionStartDate)}}</p>
                                            <p class="small text-success">Sitter Subscription EndDate: {{dateFormatter(user.SitterSubscriptionEndDate)}}</p>
                                </div>
                                <p v-if="user.CustomerId!=0" class="small"> CustomerId: <strong>{{user.CustomerId}}</strong></p> 
                                <div v-if="user.IsCustomerSubscription">
                                            <p class="small text-success">Customer Subscription StartDate: {{dateFormatter(user.CustomerSubscriptionStartDate)}}</p>
                                            <p class="small text-success">Customer Subscription EndDate: {{dateFormatter(user.CustomerSubscriptionEndDate)}}</p>
                                </div>
                                
                                
                                <p class="small"> Registration Date: {{dateFormatter(user.RegistrationDate)}}</p>
                                <p class="small"> Registration Method: {{user.RegisterationMethod}}</p>
                                <p class="small" v-bind:class="{'confirmed': user.IsConfirmedPhone}"><strong>0{{user.PhoneNumber}}</strong></p>
                                <p class="small"> Country: {{user.CountryName}}</p>
                                
                                <button v-if="user.IsEnabled" @click="disableAccount(user.Email)" style="margin:3px;" class="btn btn-sm btn-danger pull-right">Disable Access</button>
                                <button v-if="!user.IsEnabled" @click="enableAccount(user.Email)" style="margin:3px;" class="btn btn-sm btn-success pull-right">Enable Access</button>
                                <button @click="updateEmail(user.Email)" style="margin:3px;" class="btn btn-sm pull-right">Change Email</button> 
                                <button @click="updatePhone(user.Email)" style="margin:3px;" class="btn btn-sm pull-right">Change Phone</button> 
                                <button @click="confirmPhone(user.Email)" style="margin:3px;" class="btn btn-sm pull-right">Confirm Phone</button>
                                
                
                            </div>
                                                    
                        
                          
                 
                                
                    </div>
                    <br>
          
                </div>
                
                </br>

                
              </div>
               <div v-if="loading">
                <div class="spinner">
                    <div class="bounce1"></div>
                    <div class="bounce2"></div>
                    <div class="bounce3"></div>
                </div>
             </div>
                <div class="col-md-offset-3 col-md-6" v-if="!loading && usersList.length==0">
                
                    <div class="sitterListbox card"><p><i class="fa fa-warning"/> Ooopsy, no results match your search.</p></div>
                
                </div>  
                
            </div>
           
    
</div>
</template>

<script>
import auth from '../../auth/index'
import store from '../../data/store'
import commonApi from '../../services/commonApi'
import customerApi from '../../services/customerApi'


export default {
 data() {
    return {
      error: '',
      datacollection: null,
      usersList: '',
      alert: '',
      loading: true,
      searchData: {
          SearchText: ''
      },
      searching: false,

      disableAccountDto: {
          Email: ''
      },

      confirmPhoneDto: {
          Email: ''
      },
      updatePhoneDto: {
          Email: '',
          NewPhone: ''
      },
      updateEmailDto: {
          OldEmail: '',
          NewEmail: ''
      },
      emailConfirmed: true,
      title: "Dupaws admin control",
      pending: true
    }
  },
  updated: function(){
      $('[data-toggle="popover"]').popover();
  
        // $zopim(function (){
        //     $zopim.livechat.hideAll();
            
        // });

        
        if (this.userRoleComp!="Admin"){
            this.$router.push({path: '/404'})
            return;
        }
  },
  mounted: function () {
    this.getFilteredUsers()
    // $zopim(function (){
    //     $zopim.livechat.hideAll();
        
    // });
  },
  methods: {
     updateEmail(email){
        var self = this
        swal({
            title: "Enter new Email",
            type: "input",
            showCancelButton: true,
            closeOnConfirm: false,
            inputPlaceholder: "New Email"
            }, function (inputValue) {
                if (inputValue === false) return false;
                if (inputValue === "") {
                swal.showInputError("Oops, please a valid email");
                return false
                }
                else{
                self.updateEmailDto.OldEmail = email
                self.updateEmailDto.NewEmail = inputValue
                console.log('sending now')
                self.updateEmailRequest(self.updateEmailDto)
                return;

                }
            });
       
    },
    updatePhone(email){
        var self = this
     
        swal({
            title: "Enter user new phone no.",
            type: "input",
            showCancelButton: true,
            closeOnConfirm: false,
            inputPlaceholder: "New Phone Number"
            }, function (inputValue) {
                if (inputValue === false) return false;
                if (inputValue === "") {
                swal.showInputError("Oops, please a valid phone number");
                return false
                }
                else{
                self.updatePhoneDto.Email = email
                self.updatePhoneDto.NewPhone = inputValue
                console.log('sending now')
                self.updatePhoneRequest(self.updatePhoneDto)
                return;

                }
            });
       
    },
    confirmPhone(email){
        var self = this
        self.confirmPhoneDto.Email = email
        self.confirmPhoneNumber(self.confirmPhoneDto)
    },
      confirmPhoneNumber(confirmPhoneDto){
        var self = this
          $.ajax("https://www.dupaws.com/services/api/admin/confirmPhone",  {
                    type: 'POST',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    data: JSON.stringify(confirmPhoneDto),
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                        swal("","Phone confirmed successfully", "success")
                        
                    },
                    error: function () {
                        swal("","Phone couldn't be confirmed", "warning")
                    }
                }); 
    },
      disableAccount(email){
        var self = this
        self.disableAccountDto.Email = email
          $.ajax("https://www.dupaws.com/services/api/admin/disableAccount",  {
                    type: 'POST',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    data: JSON.stringify(self.disableAccountDto),
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                        swal("","Account disabled successfully", "success")
                        
                    },
                    error: function () {
                        swal("","Account couldn't be disabled", "warning")
                    }
                }); 
    },
      enableAccount(email){
        var self = this
        self.disableAccountDto.Email = email
          $.ajax("https://www.dupaws.com/services/api/admin/enableAccount",  {
                    type: 'POST',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    data: JSON.stringify(self.disableAccountDto),
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                        swal("","Account Enabled Successfully", "success")
                        
                    },
                    error: function () {
                        swal("","Account couldn't be enabled", "warning")
                    }
                }); 
    },
    updatePhoneRequest(updatePhoneDto){
        var self = this
                $.ajax("https://www.dupaws.com/services/api/admin/updatePhone",  {
                    type: 'POST',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    data: JSON.stringify(updatePhoneDto),
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                        swal("","Phone changed successfully", "success")
                        
                    },
                    error: function () {
                        swal("","Phone couldn't be changed", "warning")
                    }
                }); 
                
    },
    updateEmailRequest(updateEmailDto){
        var self = this
                $.ajax("https://www.dupaws.com/services/api/admin/updateEmail",  {
                    type: 'POST',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    data: JSON.stringify(updateEmailDto),
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                        swal("","Email changed successfully", "success")
                        
                    },
                    error: function () {
                        swal("","Email couldn't be changed", "warning")
                    }
                }); 
                
    },
      dateFormatter: function(date){
            return moment(date).format('DD MMM YYYY')
      },
      getFilteredUsers: function(){
        var self = this
        $.ajax("https://www.dupaws.com/services/api/admin/getFilteredUsers/",  {
                type: 'POST',
                beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                },
                data: JSON.stringify(self.searchData),
                dataType:"json",
                contentType: "application/json; charset=utf-8",
                crossDomain: true,
                success: function (data) {
                    self.loading = false
                    self.searching = false
                    
                    self.usersList  = data
                },
                error: function (error) {
                    self.loading = false
                    self.searching = false
                    
                    
                    
                }
            }); 
    
      },
      getSearchText: function(){
           sessionStorage.setItem('UsersSearch', this.searchData.SearchText)
             this.loading = true
          this.getFilteredUsers()
      },
  },   
  watch:{
     
   },
   head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function () {
      return {
        inner: this.title
      }
    }
  },
  computed: {
    countriesListComp: function(){
      return store.getters.CountriesList
    },
    errorMsg: function () {
      return this.error
    },
    alertMsg: function () {
      return this.alert
    },
    userRoleComp: function(){
       return store.getters.userRole
     }
    
  }
  
}

 
</script>
<style scoped>

.filters{
    padding: 10px;
    border: 1px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
}

.confirmed{
    font-weight: 700;
    color: green;
}

.reviews {
    margin-bottom: 0px;
    vertical-align: bottom;
    font-size: medium;
    margin-left: 0px;

}


.align-right {
  margin-left: auto;
}

.sitterListbox {
  display:flex;
  padding: 10px;
  flex-wrap: wrap;
  
}

.bottom-row {
  display: flex;
  justify-content: space-between
}

.sitterListbox .profile-img {
  height:75px;
  width:75px;
}

.sitterListbox .profile-body {
  flex: 3;
  padding-left: 10px;
  flex-wrap:wrap;
  
  
  
}

.sitterListbox .profile-body .profile-body-details{
  display:flex;
  flex-wrap: nowrap;
}

.sitterListbox .profile-body .profile-body-aboutme {
  display: flex;
  
}

.homewrapper{
    
    display: flex;
    box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);
    background-color: aliceblue;
    transition: 0.3s;
    border-radius: 8px;
    border-bottom-width: inherit;
}

.home-icons {
  padding:3px;
}

.sitterListbox .profile-body h2 {
  margin-top:0px;
  margin-bottom:0px;
}

.sitterListbox .profile-price {
  flex: 1;
  
}

.inline {
  display: inline;
  vertical-align: middle;
  padding-right: 1px;
  
}


.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
    background-color: #ffffff;
    opacity: 1;
}


.fa-heart-o {
  color:#848484; opacity: 0.7;
}


.favorite {
    color:#af1818; opacity: 0.7;
    padding-left:10px;
    
}

.favorite:hover {
    opacity: 1;
}

.favorite:active {
    
    transform: scale(1.1);
}

.card {
    /* Add shadows to create the "card" effect */
    
    transition: 0.3s;
    border:1px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
    
    
}



/* On mouse-over, add a deeper shadow */
.card:hover {
    box-shadow: 0 10px 16px 0 rgba(1,0,0,0.2);
    background:  aliceblue;
    opacity: 1;
    
}
    
/* Add some padding inside the card container */

</style>


// WEBPACK FOOTER //
// UsersDashboard.vue?45835df4